<template>
    <div class="users-edit">
        <button
            type="button"
            class="button button--icon button--darkgray"
            @click="showModal = true"
        >
            <IconPencil class="button__icon" />
            <span v-t="'misc.edit'"></span>
        </button>

        <portal to="modals">
            <Modal
                v-if="showModal"
                name="users-edit"
                class="users-edit__modal"
                :title="$t(modalTitle)"
                @close="showModal = false"
            >
                <template #content>
                    <form id="users-form" class="users-edit__form" @submit.prevent="submit">
                        <Grid v-if="'customer' in schema && customers.length">
                            <Column>
                                <FormField
                                    name="customer"
                                    :label="schema.customer.label"
                                    :required="schema.customer.required"
                                    :error="error"
                                >
                                    <CustomSelect
                                        v-model="customerId"
                                        emit-prop="id"
                                        view-label="name"
                                        :options="customers"
                                        clearable
                                    />
                                </FormField>
                            </Column>
                        </Grid>
                        <Grid>
                            <Column v-if="'role' in schema" :span="6">
                                <FormField
                                    name="roles"
                                    :label="$t('crm.users.list.role')"
                                    :error="error"
                                    class="users-edit__roles"
                                >
                                    <Checkbox
                                        v-for="role in schema.role.child.choices"
                                        :key="role.value"
                                        v-model="values.role"
                                        :value="role.value"
                                    >
                                        {{ role.display_name }}
                                    </Checkbox>
                                </FormField>
                            </Column>
                            <Column v-if="'languages' in schema && languages.length" :span="6">
                                <FormField
                                    name="languages"
                                    :label="schema.languages.label"
                                    :required="schema.languages.required"
                                    :error="error"
                                >
                                    <MultiSelect
                                        v-model="values.languages"
                                        :options="languages"
                                        :form-value-text="(item) => item.label"
                                        emit-prop="id"
                                        with-filter
                                        paginate
                                        width="100%"
                                    >
                                        <template #default="{ item }">
                                            {{ item.label }}
                                        </template>
                                    </MultiSelect>
                                </FormField>
                            </Column>
                        </Grid>
                    </form>
                </template>

                <template #bottom>
                    <div class="modal__confirm">
                        <button
                            v-t="'misc.cancel'"
                            type="button"
                            class="button button button--gray modal__confirm-button"
                            @click.prevent="showModal = false"
                        />
                        <button
                            v-t="'misc.save'"
                            :class="['button modal__confirm-button', { 'is-disabled': !valid }]"
                            type="submit"
                            form="users-form"
                            :disabled="!valid"
                        />
                    </div>
                </template>
            </Modal>
        </portal>
    </div>
</template>

<script>
import { Checkbox, FormField, MultiSelect } from '@speechki-frontend/shared/ui/forms';
import { Grid, Column } from '@speechki-frontend/shared/ui/Grid';
import { Modal } from '@speechki-frontend/shared/ui/modals';
import { IconPencil } from '@speechki-frontend/shared/ui/icons';

export default {
    name: 'UsersEdit',
    components: {
        Checkbox,
        FormField,
        Grid,
        Column,
        Modal,
        MultiSelect,
        IconPencil,
    },
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
        schema: {
            type: Object,
            required: true,
        },
        customers: {
            type: Array,
            default: () => [],
        },
        languages: {
            type: Array,
            default: () => [],
        },
        modalTitle: {
            type: String,
            required: true,
        },
    },
    emits: ['save'],
    data() {
        return {
            loading: false,
            error: undefined,
            customerId: 0,
            showModal: false,
            values: {
                role: this.modelValue.role.map(({ slug }) => slug),
                languages: this.modelValue.languages.map(({ slug }) => slug),
            },
        };
    },
    computed: {
        valid() {
            return true;
        },
    },
    methods: {
        submit() {
            this.showModal = false;
            this.$emit('save', { ...this.modelValue, ...this.values });
        },
    },
};
</script>

<style src="./UsersEdit.scss" lang="scss"></style>
